var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDynamicPriceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Dynamic_Price_Icon_svg__clip0_9409_14181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 9.835l-1.19-3.318-.59-1.647-.094.286-4.063 9.486H2.806v1.123h5.97v-.049l.06.033 3.298-7.664.771 2.152L14 9.835zM15.957 19.77l1.19 3.32.59 1.645.094-.285 4.064-9.433h5.299v-1.123h-5.97v-.005l-.103-.03-3.297 7.662-.772-2.153-1.095.403z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.953 11.207l-.678 1.39a2.771 2.771 0 00-1.456-.494c-.776 0-1.294.508-1.554 1.524h2.696l-.32.74h-2.5v.494h2.376l-.338.74h-1.902c.232 1.086.768 1.628 1.609 1.626a2.817 2.817 0 001.663-.646v1.556a3.378 3.378 0 01-1.673.412 2.943 2.943 0 01-2.208-.846 3.775 3.775 0 01-.987-2.1h-.839l.338-.74h.434v-.338a.895.895 0 010-.165h-.74l.321-.74h.434a3.826 3.826 0 011.1-2.124 3.052 3.052 0 012.199-.837 4.44 4.44 0 012.023.556"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Dynamic_Price_Icon_svg__clip0_9409_14181"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.763 4.737)",
    d: "M0 0h24.474v20.132H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/Dynamic_Price_Icon.100499df.svg";
export { SvgDynamicPriceIcon as ReactComponent };